import { render } from "./XmlHeadDataView.vue?vue&type=template&id=771f5f47&scoped=true&ts=true"
import script from "./XmlHeadDataView.vue?vue&type=script&lang=ts"
export * from "./XmlHeadDataView.vue?vue&type=script&lang=ts"

import "./XmlHeadDataView.vue?vue&type=style&index=0&id=771f5f47&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771f5f47"]])

export default __exports__